import { Link } from "react-router-dom";
import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const products = [
  {
    id: 1,
    defaultImg: "images/prd-1.jpg",
    hoverImg: "images/prd-2.jpg",
    title: "Aoremen Cotton Blended Regular Tops - Black",
    price: "$30",
    oldPrice: "$70",
    discount: "63% Off",
    colors: [
      { color: "#fbc101", src: "images/prd-1.jpg" },
      { color: "#b41e4e", src: "images/prd-2.jpg" },
      { color: "#f0afaf", src: "images/prd-3.jpg" },
    ],
  },
  {
    id: 2,
    defaultImg: "images/white-top.jpg",
    hoverImg: "images/white-top-with-jacket.jpg",
    title: "Aoremen Cotton Blended Regular Tops - Black",
    price: "$30",
    oldPrice: "$70",
    discount: "63% Off",
    colors: [
      { color: "#fff", src: "images/white-top.jpg" },
      { color: "#000", src: "images/white-top-2.jpg" },
      { color: "#f0afaf", src: "images/white-top-with-jacket.jpg" },
    ],
  },
  {
    id: 3,
    defaultImg: "images/kasmiri.jpg",
    hoverImg: "images/tranding.jpg",
    title: "Aoremen Cotton Blended Regular Tops - Black",
    price: "$30",
    oldPrice: "$70",
    discount: "63% Off",
    colors: [
      { color: "#fff", src: "images/kasmiri.jpg" },
      { color: "#000", src: "images/black-top.jpg" },
      { color: "#f0afaf", src: "images/tranding.jpg" },
    ],
  },
  {
    id: 4,
    defaultImg: "images/bridal-lehenga.jpg",
    hoverImg: "images/bridal-lehenga-hover.jpg",
    title: "Aoremen Cotton Blended Regular Tops - Black",
    price: "$30",
    oldPrice: "$70",
    discount: "63% Off",
    colors: [
      { color: "#fff", src: "images/bridal-lehenga.jpg" },
      { color: "#000", src: "images/bridal-lehenga-hover.jpg" },
      { color: "#f0afaf", src: "images/shopdressup-2.jpg" },
    ],
  },
  {
    id: 5,
    defaultImg: "images/fitness.jpg",
    hoverImg: "images/fitness-2.jpg",
    title: "Aoremen Cotton Blended Regular Tops - Black",
    price: "$30",
    oldPrice: "$70",
    discount: "63% Off",
    colors: [
      { color: "#fff", src: "images/fitness.jpg" },
      { color: "#000", src: "images/fitness-2.jpg" },
      { color: "#f0afaf", src: "images/fitness.jpg" },
    ],
  },
  {
    id: 6,
    defaultImg: "images/prd-1.jpg",
    hoverImg: "images/prd-2.jpg",
    title: "Aoremen Cotton Blended Regular Tops - Black",
    price: "$30",
    oldPrice: "$70",
    discount: "63% Off",
    colors: [
      { color: "#fbc101", src: "images/prd-1.jpg" },
      { color: "#b41e4e", src: "images/prd-2.jpg" },
      { color: "#f0afaf", src: "images/prd-3.jpg" },
    ],
  },
  {
    id: 7,
    defaultImg: "images/white-top.jpg",
    hoverImg: "images/white-top-with-jacket.jpg",
    title: "Aoremen Cotton Blended Regular Tops - Black",
    price: "$30",
    oldPrice: "$70",
    discount: "63% Off",
    colors: [
      { color: "#fff", src: "images/white-top.jpg" },
      { color: "#000", src: "images/white-top-2.jpg" },
      { color: "#f0afaf", src: "images/white-top-with-jacket.jpg" },
    ],
  },
  {
    id: 8,
    defaultImg: "images/kasmiri.jpg",
    hoverImg: "images/tranding.jpg",
    title: "Aoremen Cotton Blended Regular Tops - Black",
    price: "$30",
    oldPrice: "$70",
    discount: "63% Off",
    colors: [
      { color: "#fff", src: "images/kasmiri.jpg" },
      { color: "#000", src: "images/black-top.jpg" },
      { color: "#f0afaf", src: "images/tranding.jpg" },
    ],
  },
];

const ProductDetails = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 5000,
    slidesToShow: 4, // Adjust as needed
    slidesToScroll: 3,
    arrows: false,
    appendDots: (dots) => (
      <div
        style={{
          backgroundColor: "white",
          padding: "10px",
          borderRadius: "5px",
        }}
      >
        <ul
          style={{
            margin: 0,
            padding: 0,
            display: "flex",
            justifyContent: "center",
            listStyle: "none",
          }}
        >
          {dots}
        </ul>
      </div>
    ),
    customPaging: (i) => <div className="custom-dot" />,
  };

  return (
    <>
      <div
        className="inner-banner banner"
        style={{ background: 'url("../images/product-banner-2.jpg")' }}
      >
        <div className="container">
          <div className="inner-banner-txt">
            <h1 className="banner-banner-heading text-white fs-45">
              fashjhn Cotton Blended Regular Tops - Black{" "}
            </h1>
            <nav aria-label="breadcrumb" className="breadcrumb-nav">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/">Home</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/new-arrivals">New arrivals</Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  fashjhn Cotton Blended Regular Tops - Black{" "}
                </li>
              </ol>
            </nav>
          </div>
        </div>
      </div>
      <section className="main-section product-detail-pg">
        <div className="container">
          <div className="row">
            <div className="col-lg-5 col-sm-5 col-xs-12">
              <div className="owl-sticky">
                {/*Carousel Wrapper*/}
                <div id="sync3" className="owl-carousel owl-theme">
                  <div className="item">
                    <a data-fancybox="gallery" href="images/prd-1.jpg">
                      <img
                        className="d-block w-100"
                        src="images/prd-1.jpg"
                        alt="First slide"
                      />
                    </a>
                  </div>
                  <div className="item">
                    <a href="images/prd-2.jpg" data-fancybox="gallery">
                      <img
                        className="d-block w-100"
                        src="images/prd-2.jpg"
                        alt="First slide"
                      />
                    </a>
                  </div>
                  <div className="item">
                    <a href="images/prd-3.jpg" data-fancybox="gallery">
                      <img
                        className="d-block w-100"
                        src="images/prd-3.jpg"
                        alt="First slide"
                      />
                    </a>
                  </div>
                  <div className="item">
                    <a data-fancybox="gallery" href="images/prd-1.jpg">
                      <img
                        className="d-block w-100"
                        src="images/prd-1.jpg"
                        alt="First slide"
                      />
                    </a>
                  </div>
                  <div className="item">
                    <a href="images/prd-2.jpg" data-fancybox="gallery">
                      <img
                        className="d-block w-100"
                        src="images/prd-2.jpg"
                        alt="First slide"
                      />
                    </a>
                  </div>
                  <div className="item">
                    <a href="images/prd-3.jpg" data-fancybox="gallery">
                      <img
                        className="d-block w-100"
                        src="images/prd-3.jpg"
                        alt="First slide"
                      />
                    </a>
                  </div>
                </div>
                <div id="sync4" className="owl-carousel owl-theme xl-arrow">
                  <div className="item">
                    <img
                      className="d-block w-100"
                      src="images/prd-1.jpg"
                      alt="First slide"
                    />
                  </div>
                  <div className="item">
                    <img
                      className="d-block w-100"
                      src="images/prd-2.jpg"
                      alt="First slide"
                    />
                  </div>
                  <div className="item">
                    <img
                      className="d-block w-100"
                      src="images/prd-3.jpg"
                      alt="First slide"
                    />
                  </div>
                  <div className="item">
                    <img
                      className="d-block w-100"
                      src="images/prd-1.jpg"
                      alt="First slide"
                    />
                  </div>
                  <div className="item">
                    <img
                      className="d-block w-100"
                      src="images/prd-2.jpg"
                      alt="First slide"
                    />
                  </div>
                  <div className="item">
                    <img
                      className="d-block w-100"
                      src="images/prd-3.jpg"
                      alt="First slide"
                    />
                  </div>
                </div>
              </div>
              {/*/.Carousel Wrapper*/}
            </div>
            {/* col */}
            <div className="col-lg-7 col-sm-7 col-xs-12">
              <div className="quickview-product">
                <div className="prd-info">
                  <h2 className="prd-name">
                    Aoremen Cotton Blended Regular Tops -
                    <span className="prd-color">Black</span>
                  </h2>
                  <div className="status-bar status-bar-dtpg">
                    <p>
                      <a href="#">
                        <i className="lni lni-star-filled" />
                        <i className="lni lni-star-filled" />
                        <i className="lni lni-star-filled" />
                        <i className="lni lni-star-filled" />
                        <i className="lni lni-star" />
                        (4.7) 104 Reviews
                      </a>{" "}
                      | SKU: 467216{" "}
                    </p>
                  </div>
                  <div className="quickview-content">
                    <p>
                      text Ipsum is basically fake text of the printing and
                      typesetting industry. Loremen Ipsum has been the business'
                      standard faker text since the 1500s, when an obscure
                      printer took a kitchen of type and blended it to make a
                      sort model book. It has endure five centuries, yet in
                      addition the jump into electronic typesetting, remaining
                      basically unaltered.{" "}
                    </p>
                    <p>
                      text Ipsum is basically fake text of the printing and
                      typesetting industry. Loremen Ipsum has been the business'
                      standard faker text since the 1500s, when an obscure
                      printer took a kitchen of type and blended it to make a
                      sort model book. It has endure five centuries, yet in
                      addition the jump into electronic typesetting, remaining
                      basically unaltered.{" "}
                    </p>
                    <ul className="prd-point">
                      <li>Set Contents:With 2 Piece</li>
                      <li>Color: Black</li>
                      <li>Toop Fabric: Georgette </li>
                      <li>Fabric: Georgette </li>
                      <li>Yellow</li>
                      <li>Top Work:Printed</li>
                    </ul>
                    <p>Measurements for garments in inches:</p>
                    <p className="fs-11">
                      Little | Bust 34” | Waist 28” (Extends up to 40") | Hips
                      46” | Length 33” Medium | Bust 36” | Waist 30” (Extends up
                      to 42") | Hips 49” | Length 34” Large | Bust 38” | Waist
                      32” (Extends up to 44") | Hips 52” | Length 35”
                    </p>
                    <p className="tcolor">
                      {" "}
                      Have inquiries concerning estimating, fit, or styling?
                      Send us a talk or call us at 000-999-1111 during business
                      hours 9 AM - 5 PM EST Monday-Friday!{" "}
                    </p>
                  </div>
                  <div className="quick-view-box fs-13 border">
                    <div className="row">
                      <div className="col-lg-6 col-sm-6 col-xs-12">
                        <div className="prices">
                          <p>prices</p>
                          <span>$30</span> <del>$70</del>{" "}
                          <span className="tcolor">63% Off</span>
                        </div>
                        <div className="color-option text-left">
                          <ul className="list-style">
                            <li>
                              <label>
                                <input
                                  type="radio"
                                  name="color-option"
                                  defaultChecked=""
                                  defaultValue="white"
                                />
                                <span
                                  className="form-option-variant"
                                  style={{ background: "#fbc101" }}
                                />
                              </label>
                            </li>
                            <li>
                              <label>
                                <input
                                  type="radio"
                                  name="color-option"
                                  defaultValue="black"
                                />
                                <span
                                  className="form-option-variant"
                                  style={{ background: "#b41e4e" }}
                                />
                              </label>
                            </li>
                            <li>
                              <label>
                                <input
                                  type="radio"
                                  name="color-option"
                                  defaultValue="red"
                                />
                                <span
                                  className="form-option-variant"
                                  style={{ background: "#f0afaf" }}
                                />
                              </label>
                            </li>
                          </ul>
                        </div>
                        <div className="prd-size">
                          <p>
                            Size: Required{" "}
                            <a
                              href="#"
                              className="link tcolor"
                              data-toggle="modal"
                              data-target="#sizechart"
                            >
                              Size Chart
                            </a>
                          </p>
                          <ul className="list-style">
                            <li>
                              <label>
                                <input
                                  type="radio"
                                  name="size-option"
                                  defaultChecked=""
                                  defaultValue="Small"
                                />
                                <span className="pd-size-option">Small</span>
                              </label>
                            </li>
                            <li>
                              <label>
                                <input
                                  type="radio"
                                  name="size-option"
                                  defaultValue="Medium"
                                />
                                <span className="pd-size-option">Medium</span>
                              </label>
                            </li>
                            <li>
                              <label>
                                <input
                                  type="radio"
                                  name="size-option"
                                  defaultValue="Large"
                                />
                                <span className="pd-size-option">Large</span>
                              </label>
                            </li>
                          </ul>
                        </div>
                        <div className="quantity-box">
                          <p>Quantity</p>
                          <div className="number-input md-number-input">
                            <button
                              onclick="this.parentNode.querySelector('input[type=number]').stepDown()"
                              className="minus icon-btn"
                            >
                              <i className="lni lni-minus" />
                            </button>
                            <input
                              className="quantity form-control"
                              min={0}
                              name="quantity"
                              defaultValue={1}
                              type="number"
                            />
                            <button
                              onclick="this.parentNode.querySelector('input[type=number]').stepUp()"
                              className="plus icon-btn"
                            >
                              <i className="lni lni-plus" />
                            </button>
                          </div>
                        </div>
                        <div className="action-box">
                          <button>Add to Cart</button>
                          <button>Add to WishList</button>
                        </div>
                      </div>
                      <div className="col-lg-6 col-sm-6 col-xs-12 align-self-center">
                        <div className="store-box">
                          <span className="sm-btn bg-green text-white">
                            Available online
                          </span>
                          <div className="location-box bg-light  p-4 mt-4">
                            <p>Buy Online and Pick Up In Store</p>
                            <div className="cart-nav text-left  mb-3">
                              <div className="store-search text-left">
                                <h6>Select a Store</h6>
                                <p className="fs-13 text-left">
                                  <span className="material-icons">
                                    location_on
                                  </span>
                                  <a href="#">Use my current location</a>
                                </p>
                                <form>
                                  <input
                                    type="text"
                                    name="zip"
                                    placeholder="Enter zipcode or state"
                                    className="form-control"
                                  />
                                </form>
                              </div>
                            </div>
                            <p>
                              Our Group Is Glad To Address Any Inquiries. For
                              Help, Look at Our <a href="#"> FAQ </a> Or
                              <a href="emailtto:contact@gmail.com">e-mail</a> .
                              We're Consistently Here To Help.{" "}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* col */}
          </div>
        </div>
        <div className="prd-tab">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="prd-tabs responsive-tab">
                  <div className="cust-nav1">
                    <div
                      className="nav nav-pills"
                      id="custom-tab1"
                      role="tablist"
                      aria-orientation="vertical"
                    >
                      <a
                        href="#tab2"
                        className="nav-link active"
                        data-toggle="pill"
                      >
                        Description
                      </a>
                      <a href="#tab3" className="nav-link" data-toggle="pill">
                        Additional information
                      </a>
                      <a href="#tab4" className="nav-link" data-toggle="pill">
                        Reviews (3)
                      </a>
                    </div>
                  </div>
                  <div id="content" className="tab-content" role="tablist">
                    <div
                      id="tab2"
                      className="card tab-pane show active"
                      aria-labelledby="tab2"
                    >
                      <div className="card-header" id="heading-A">
                        <h5 className="mb-0">
                          <a
                            data-toggle="collapse"
                            href="#collapse-A"
                            aria-expanded="true"
                            aria-controls="collapse-A"
                          >
                            Description{" "}
                            <span className="accordin-icon">
                              <i className="mins" />
                            </span>
                          </a>
                        </h5>
                      </div>
                      <div
                        id="collapse-A"
                        className="collapse show"
                        data-parent="#content"
                        role="tabpanel"
                        aria-labelledby="heading-A"
                      >
                        <div className="card-body">
                          <div className="row">
                            <div className="col-lg-12 col-sm-12">
                              <div className="tab-txt">
                                <p>
                                  text Ipsum is basically fake text of the
                                  printing and typesetting industry. Loremen
                                  Ipsum has been the business' standard faker
                                  text since the 1500s, when an obscure printer
                                  took a kitchen of type and blended it to make
                                  a sort model book. It has endure five
                                  centuries, yet in addition the jump into
                                  electronic typesetting, remaining basically
                                  unaltered. It was popularised in the 1960s
                                  with the release of Letraset sheets containing
                                  Loremen Ipsum passages, and more recently with
                                  desktop publishing software like Aldus
                                  PageMaker including versions of Loremen Ipsum.
                                </p>
                                <p>
                                  {" "}
                                  text Ipsum is basically fake text of the
                                  printing and typesetting industry. Loremen
                                  Ipsum has been the business' standard faker
                                  text since the 1500s, when an obscure printer
                                  took a kitchen of type and blended it to make
                                  a sort model book. It has endure five
                                  centuries, yet in addition the jump into
                                  electronic typesetting, remaining basically
                                  unaltered. It was popularised in the 1960s
                                  with the release of Letraset sheets containing
                                  Loremen Ipsum passages, and more recently with
                                  desktop publishing software like Aldus
                                  PageMaker including versions of Loremen Ipsum.
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>{" "}
                    {/* tab */}
                    <div
                      id="tab3"
                      className="card tab-pane"
                      aria-labelledby="tab3"
                    >
                      <div className="card-header" id="heading-B">
                        <h5 className="mb-0">
                          <a
                            data-toggle="collapse"
                            href="#collapse-B"
                            aria-expanded="false"
                            aria-controls="collapse-B"
                            className="collapsed"
                          >
                            Specification{" "}
                            <span className="accordin-icon">
                              <i className="mins" />
                            </span>
                          </a>
                        </h5>
                      </div>
                      <div
                        id="collapse-B"
                        className="collapse"
                        data-parent="#content"
                        aria-labelledby="heading-B"
                      >
                        <div className="card-body">
                          <div className="row">
                            <div className="col-lg-12 col-sm-12">
                              <div className="tab-txt table-container">
                                <table>
                                  <tbody>
                                    <tr>
                                      <td>
                                        <strong>Weight</strong>
                                      </td>
                                      <td>300 g</td>
                                      <td>
                                        <strong>Type</strong>
                                      </td>
                                      <td>Cottan</td>
                                    </tr>
                                    <tr>
                                      <td>
                                        <strong>Dimensions</strong>
                                      </td>
                                      <td>10 x 10 x 15 cm</td>
                                      <td>
                                        <strong>Size</strong>
                                      </td>
                                      <td>5.5 Mtr</td>
                                    </tr>
                                    <tr>
                                      <td>
                                        <strong>Brand</strong>
                                      </td>
                                      <td>Nivea</td>
                                      <td>
                                        <strong>Type</strong>
                                      </td>
                                      <td>Tube</td>
                                    </tr>
                                    <tr>
                                      <td>
                                        <strong>Active substance</strong>
                                      </td>
                                      <td>Urea</td>
                                      <td>
                                        <strong>Side Effects</strong>
                                      </td>
                                      <td>Non-drowsy</td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>{" "}
                    {/* tab */}
                    <div
                      id="tab4"
                      className="card tab-pane"
                      aria-labelledby="tab4"
                    >
                      <div className="card-header" id="heading-C">
                        <h5 className="mb-0">
                          <a
                            data-toggle="collapse"
                            href="#collapse-C"
                            aria-expanded="false"
                            aria-controls="collapse-C"
                            className="collapsed"
                          >
                            Reviews (3){" "}
                            <span className="accordin-icon">
                              <i className="mins" />
                            </span>
                          </a>
                        </h5>
                      </div>
                      <div
                        id="collapse-C"
                        className="collapse"
                        data-parent="#content"
                        aria-labelledby="heading-C"
                      >
                        <div className="card-body">
                          <div className="row">
                            <div className="col-lg-12 col-sm-12">
                              <div className="tab-txt">
                                <div className="review-tab-action border-bottom">
                                  <h6>Reviews</h6>
                                  <p>
                                    <strong>
                                      {" "}
                                      S-Works Aethos - Rated 4.8/5 based on 50
                                      reviews{" "}
                                    </strong>
                                  </p>
                                </div>
                                <div className="reviews-list mt-2">
                                  <div className="row border-bottom mb-2 pb-2">
                                    <div className="col-lg-12">
                                      <div className="rating">
                                        <i className="lni lni-star-filled" />
                                        <i className="lni lni-star-filled" />
                                        <i className="lni lni-star-filled" />
                                        <i className="lni lni-star" />
                                        <i className="lni lni-star" />
                                      </div>
                                      <div className="rating-info">
                                        <date>5 Aug, 2021</date>
                                        <span className="rating-tag">
                                          Excellent product, Thank you!
                                        </span>
                                        <h6 className="c-name mb-2">
                                          Jeannette Spicer
                                        </h6>
                                      </div>
                                      <p>
                                        I'm extremely satisfied with the
                                        assistance I got and the client support
                                        delegate that helped me.
                                      </p>
                                    </div>
                                  </div>
                                  {/*repect*/}
                                  <div className="row border-bottom mb-2 pb-2">
                                    <div className="col-lg-12">
                                      <div className="rating">
                                        <i className="lni lni-star-filled" />
                                        <i className="lni lni-star-filled" />
                                        <i className="lni lni-star-filled" />
                                        <i className="lni lni-star" />
                                        <i className="lni lni-star" />
                                      </div>
                                      <div className="rating-info">
                                        <date>5 Aug, 2021</date>
                                        <span className="rating-tag">
                                          Excellent product, Thank you!
                                        </span>
                                        <h6 className="c-name mb-2">
                                          Jeannette Spicer
                                        </h6>
                                      </div>
                                      <p>
                                        I'm extremely satisfied with the
                                        assistance I got and the client support
                                        delegate that helped me.
                                      </p>
                                    </div>
                                  </div>
                                  {/*repect*/}
                                  <div className="row border-bottom mb-2 pb-2">
                                    <div className="col-lg-6 col-sm-8 col-xs-12">
                                      <div className="review-model pt-4">
                                        <form>
                                          <h4 className="mb-2">
                                            {" "}
                                            Write a review
                                          </h4>
                                          <div className="star-rating">
                                            <input
                                              type="radio"
                                              id="5-stars"
                                              name="rating"
                                              defaultValue={5}
                                            />
                                            <label
                                              htmlFor="5-stars"
                                              className="star"
                                            >
                                              ★
                                            </label>
                                            <input
                                              type="radio"
                                              id="4-stars"
                                              name="rating"
                                              defaultValue={4}
                                            />
                                            <label
                                              htmlFor="4-stars"
                                              className="star"
                                            >
                                              ★
                                            </label>
                                            <input
                                              type="radio"
                                              id="3-stars"
                                              name="rating"
                                              defaultValue={3}
                                            />
                                            <label
                                              htmlFor="3-stars"
                                              className="star"
                                            >
                                              ★
                                            </label>
                                            <input
                                              type="radio"
                                              id="2-stars"
                                              name="rating"
                                              defaultValue={2}
                                            />
                                            <label
                                              htmlFor="2-stars"
                                              className="star"
                                            >
                                              ★
                                            </label>
                                            <input
                                              type="radio"
                                              id="1-star"
                                              name="rating"
                                              defaultValue={1}
                                            />
                                            <label
                                              htmlFor="1-star"
                                              className="star"
                                            >
                                              ★
                                            </label>
                                          </div>
                                          <div className="field">
                                            <label>Full Name</label>
                                            <input
                                              type="text"
                                              name="tagline"
                                              className="form-control br-5"
                                              placeholder="Full Name"
                                              required=""
                                            />
                                          </div>
                                          <div className="field">
                                            <label>Email Address</label>
                                            <input
                                              type="text"
                                              name="tagline"
                                              className="form-control br-5"
                                              placeholder="Email Address"
                                              required=""
                                            />
                                          </div>
                                          <div className="field">
                                            <label>Phone</label>
                                            <input
                                              type="text"
                                              name="tagline"
                                              className="form-control br-5"
                                              placeholder="Phone"
                                              required=""
                                            />
                                          </div>
                                          <div className="field">
                                            <label>Review Title</label>
                                            <input
                                              type="text"
                                              name="tagline"
                                              className="form-control br-5"
                                              placeholder="Excellent product, Thank you!"
                                              required=""
                                            />
                                          </div>
                                          <div className="field">
                                            <label>Comment</label>
                                            <textarea
                                              name="comment"
                                              className="form-control br-5"
                                              placeholder="Write a review"
                                              required=""
                                              defaultValue={""}
                                            />
                                          </div>
                                          <div className="field mb-0">
                                            <button>
                                              Post Comment{" "}
                                              <i className="lni lni-arrow-right" />
                                            </button>
                                          </div>
                                        </form>
                                      </div>
                                    </div>
                                  </div>{" "}
                                  {/* rept */}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>{" "}
                    {/* tab */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="main-section product-section pt-0">
        <div className="container">
          <div className="main-title text-left mb-5">
            <h3 className="heading">Most Viewed</h3>
          </div>
          <Slider {...settings}>
            {products.map((product, proindex) => {
              const isLast = proindex === Number(products.length) - 1;
              return (
                <div
                  key={product.id}
                  className="item"
                  style={{ marginRight: isLast ? "0" : "20px" }}
                >
                  <div className="product">
                    <div className="product-img object-fit">
                      <div className="status-bar">
                        <span className="prd-rating br-5 bg-darkgreen text-white">
                          4.4 <i className="lni lni-star" />
                        </span>
                        <span className="prd-stauts bg-site text-white br-5">
                          Sold-Out
                        </span>
                        <span className="prd-stauts bg-green text-white br-5">
                          Stock
                        </span>
                        <button className="wishlist-btn">
                          <i className="lni lni-heart" />
                        </button>
                      </div>
                      <a href="#">
                        <img
                          src={product.defaultImg}
                          alt="product"
                          className="prd-default-img"
                        />
                        <img
                          src={product.hoverImg}
                          alt="hover"
                          className="prd-hover-img"
                        />
                      </a>
                      <div className="quick-section">
                        <button
                          className="quick-btn"
                          data-toggle="modal"
                          data-target="#modalshow"
                        >
                          Quick View
                        </button>
                      </div>
                    </div>
                    <div className="prd-info">
                      <h4 className="prd-name">
                        <a href="#" tabIndex={0}>
                          {product.title}
                        </a>
                      </h4>
                      <div className="prices">
                        <span>{product.price}</span>{" "}
                        <del>{product.oldPrice}</del>{" "}
                        <span className="tcolor">{product.discount}</span>
                      </div>
                      <div className="color-option">
                        <ul className="list-style">
                          {product.colors.map((color, index) => (
                            <li key={index} data-src={color.src}>
                              <label>
                                <input
                                  type="radio"
                                  name={`color-${product.id}`}
                                  defaultValue={color.src}
                                />
                                <span
                                  className="form-option-variant"
                                  style={{ background: color.color }}
                                />
                              </label>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </Slider>
        </div>
      </section>

      <section className="main-section subscribe-section bg-fixed">
        <div className="container">
          <div className="row">
            <div className="col-lg-7 col-sm-9 col-xs-12 m-auto">
              <div className="subscribe-form">
                <h3 className="wow fadeInUp">
                  Join the Design Center point mailing list
                </h3>
                <p>
                  Receive updates about sales, new products, and other great
                  deals.
                </p>
                <form>
                  <div className="form-group">
                    <input
                      type="email"
                      name="email"
                      className="form-control"
                      required=""
                      placeholder="Your Email Address"
                    />
                  </div>
                  <button type="submit" className="btn">
                    Subscribe
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="main-section feature">
        <div className="container">
          <div className="row">
            <div className="col-lg-7 col-sm-7 col-xs-12">
              <div className="row">
                <div className="col-lg-4 col-sm-4 col-xs-12">
                  <div className="feature-box">
                    <div className="feature-img">
                      <span className="mbri-delivery" />
                    </div>
                    <h6>Delivery</h6>
                    <p>within 3 to 7 days of the target.</p>
                  </div>
                </div>
                <div className="col-lg-4 col-sm-4 col-xs-12">
                  <div className="feature-box">
                    <div className="feature-img">
                      <span className="mbri-update" />
                    </div>
                    <h6>Returns</h6>
                    <p>
                      Within ten days of delivery, merchandise with tags
                      attached may be returned..
                    </p>
                  </div>
                </div>
                <div className="col-lg-4 col-sm-4 col-xs-12 footer-box-last">
                  <div className="feature-box">
                    <div className="feature-img">
                      <span className="mbri-lock" />
                    </div>
                    <h6>Safety</h6>
                    <p>Deliveries without contact for optimum security.</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-5 col-sm-5 col-xs-12 feature-right">
              <div className="row">
                <div className="col-lg-6 col-sm-12 col-xs-12">
                  <div className="feature-box need-help">
                    <h6>Need Help?</h6>
                    <p>Our customer service departments are open.</p>
                    <div className="feature-timeing">
                      Mon-Sat [10:00 AM - 05:30 PM]{" "}
                    </div>
                    <div>
                      <a href="mailto:contact@gmail.com" className="link">
                        Contact Us{" "}
                      </a>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 col-sm-12 col-xs-12">
                  <div className="feature-box need-help">
                    <h6>Where is my order?</h6>
                    <span className="mbri-map-pin" />
                    <a href="#" className="link">
                      Track my Order
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ProductDetails;
